import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-devex-settings',
  templateUrl: './devex-settings.component.html',
  styleUrls: ['./devex-settings.component.scss']
})
export class DevexSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
